import React from 'react';

import AdminOnboardingHeader, { AdminOnboardingSubHeader } from './AdminOnboardingHeader';
import AdminOnboardingMultiSelect from './AdminOnboardingMultiSelect';
import { type UseCase } from './Types';

import 'css/components/subdomain/admin/_AdminOnboarding.scss';

type Props = {
  onChange: (useCase: UseCase) => void;
  useCase: UseCase;
};

const AdminOnboardingWho = ({ onChange, useCase }: Props) => {
  // helpers
  const onChangeSelect = (users: string[]) => {
    onChange({
      ...useCase,
      users,
    });
  };

  const { users } = useCase;
  return (
    <div className="onboardingWho">
      <AdminOnboardingHeader>Who will you be collecting feedback from?</AdminOnboardingHeader>
      <AdminOnboardingSubHeader>
        I would like to track feedback from (select all that apply):
      </AdminOnboardingSubHeader>
      <AdminOnboardingMultiSelect
        onChange={onChangeSelect}
        options={[
          { name: 'myTeam', label: 'My team' },
          { name: 'customers', label: 'Customers' },
        ]}
        selected={users}
      />
    </div>
  );
};

export default AdminOnboardingWho;
